// CardRoutes.js
import React from "react";
import { Route, Routes } from "react-router-dom";

import ROUTES_NAVIGATION from "./routes";

import ActionTakenList from "../components/DealerManagement/Admin/LeadManagement/ActionTaken";

import AddActionToBeTaken from "../components/DealerManagement/Admin/LeadManagement/ActionToBeTaken/AddActionToBeTaken";
import ActionToBeTakenList from "../components/DealerManagement/Admin/LeadManagement/ActionToBeTaken";
import AddActionTaken from "../components/DealerManagement/Admin/LeadManagement/ActionTaken/AddActionTaken";
import AddLeadPriority from "../components/DealerManagement/Admin/LeadManagement/LeadPriority/AddLeadPriority";
import AddLeadSource from "../components/DealerManagement/Admin/LeadManagement/LeadSource/AddLeadSource";
import AddLeadStatus from "../components/DealerManagement/Admin/LeadManagement/LeadStatus/AddLeadStatus";
//import AddNewCustomer from "../components/DealerManagement/Admin/OnBoard/CustomerForm";
import AddNewLead from "../components/DealerManagement/Admin/LeadManagement/AddNewLead";
//import CustomerDetails from "../components/DealerManagement/Admin/OnBoard/CustomerDetails";
//import Dashboard from "../components/DealerManagement/Dashboard";
import LeadAllocationList from "../components/DealerManagement/Admin/LeadManagement/LeadAllocation";
import LeadPriorityList from "../components/DealerManagement/Admin/LeadManagement/LeadPriority";
import LeadSourceList from "../components/DealerManagement/Admin/LeadManagement/LeadSource";
import LeadStatusList from "../components/DealerManagement/Admin/LeadManagement/LeadStatus";
import EditLeadPriority from "../components/DealerManagement/Admin/LeadManagement/LeadPriority/EditLeadPriority";
import EditLeadStatus from "../components/DealerManagement/Admin/LeadManagement/LeadStatus/EditLeadStatus";
import EditActionTaken from "../components/DealerManagement/Admin/LeadManagement/ActionTaken/EdittActionTaken";
import AddNewBusinessPartnerType from "../components/DealerManagement/Admin/DealerManagement/BusinessPartnerType/AddBusinessPartnerType";
import BusinessPartnerTypeList from "../components/DealerManagement/Admin/DealerManagement/BusinessPartnerType/BusinessPartnerTypeList";
import EditActionToBeTaken from "../components/DealerManagement/Admin/LeadManagement/ActionToBeTaken/EditActionTakenToBeTaken";

const LeadRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES_NAVIGATION.ACTIONTAKENLIST}
        element={<ActionTakenList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDACTIONTOBETAKEN}
        element={<AddActionToBeTaken />}
      />
      <Route
        path={ROUTES_NAVIGATION.ACTIONTOBETAKENLIST}
        element={<ActionToBeTakenList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDACTIONTAKEN}
        element={<AddActionTaken />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDLEADPRIORITY}
        element={<AddLeadPriority />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDLEADSOURCE}
        element={<AddLeadSource />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDLEADSTATUS}
        element={<AddLeadStatus />}
      />
      <Route path={ROUTES_NAVIGATION.ADDNEWLEAD} element={<AddNewLead />} />
      <Route
        path={ROUTES_NAVIGATION.LEADALLOCATIONLIST}
        element={<LeadAllocationList />}
      />
      <Route
        path={ROUTES_NAVIGATION.LEADPRIORITYLIST}
        element={<LeadPriorityList />}
      />
      <Route
        path={ROUTES_NAVIGATION.LEADSOURCELIST}
        element={<LeadSourceList />}
      />

      <Route
        path={ROUTES_NAVIGATION.LEADSTATUSLIST}
        element={<LeadStatusList />}
      />

      <Route 
      path={ROUTES_NAVIGATION.EDITLEADPRIORITY}
      element={<EditLeadPriority/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.EDITLEADSTATUS}
      element={ <EditLeadStatus/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.EDITACTIONTAKEN}
      element={ <EditActionTaken/> }
      />
        <Route 
      path={ROUTES_NAVIGATION.EDITACTIONTOBETAKEN}
      element={ <EditActionToBeTaken /> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ADDBUSINESSPARTNERTYPELIST}
      element={ <AddNewBusinessPartnerType/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.BUSINESSPARTNERTYPELIST}
      element={<BusinessPartnerTypeList/>  }
      />

    </>
  );
};

export default LeadRoutes;
